var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWave = function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m22 19-2.615-1.57a4 4 0 0 0-4.557.307l-.33.264a4 4 0 0 1-4.997 0l-.33-.264a4 4 0 0 0-4.556-.306L2 19m20-6-2.615-1.57a4 4 0 0 0-4.557.307l-.33.264a4 4 0 0 1-4.997 0l-.33-.264a4 4 0 0 0-4.556-.306L2 13m20-6-2.615-1.57a4 4 0 0 0-4.557.307l-.33.264a4 4 0 0 1-4.997 0l-.33-.264a4 4 0 0 0-4.556-.306L2 7"
  })));
};
export default SvgWave;